import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';
import axios from 'axios';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import CategoryPage from './pages/CategoryPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CartPage from './pages/CartPage';
import LoginPage from './pages/LoginPage';
import SearchPage from './pages/SearchPage';
import AdminPage from './pages/AdminPage';
import CustomerCRMProfile from './pages/CustomerCRMProfile';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentCancelPage from './pages/PaymentCancelPage';
import StaticPage from './pages/StaticPage';
import OrdersPage from './pages/OrdersPage';
import AccountPage from './pages/AccountPage';
import FavoritesPage from './pages/FavoritesPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import UnsubscribePage from './pages/UnsubscribePage';
import AuthCallback from './pages/AuthCallback';
import GoogleOAuthCallback from './pages/GoogleOAuthCallback';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import HelpAdvicePage from './pages/HelpAdvicePage';
import HelpAdviceGuidePage from './pages/HelpAdviceGuidePage';
import ExpertAuthorPage from './pages/ExpertAuthorPage';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { SettingsProvider } from './context/SettingsContext';
import { FavoritesProvider } from './context/FavoritesContext';
import { PricingProvider } from './context/PricingContext';
import { ConsentProvider } from './context/ConsentContext';
import { UploadManagerProvider } from './context/UploadManagerContext';
import CookieBanner from './components/CookieBanner';
import AnalyticsTags from './components/AnalyticsTags';
import UploadTray from './components/admin/UploadTray';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  useEffect(() => {
    axios.get(`${API}/`).catch(() => {});
  }, []);

  return (
    <div className="App bg-neutral-50 min-h-screen">
      <HelmetProvider>
        <AuthProvider>
        <SettingsProvider>
          <PricingProvider>
            <CartProvider>
              <FavoritesProvider>
                <ConsentProvider>
                <UploadManagerProvider>
                <BrowserRouter>
                  <ScrollToTop />
                  <AnalyticsTags />
                  <Header />
                  <main className="min-h-[60vh]">
                    <Routes>
                      <Route path="/" element={<HomePage />} />
                      <Route path="/category/:slug" element={<CategoryPage />} />
                      <Route path="/product/:id" element={<ProductDetailPage />} />
                      <Route path="/products/:id" element={<ProductDetailPage />} />
                      <Route path="/cart" element={<CartPage />} />
                      <Route path="/login" element={<LoginPage />} />
                      <Route path="/search" element={<SearchPage />} />
                      <Route path="/orders" element={<OrdersPage />} />
                      <Route path="/account" element={<AccountPage />} />
                      <Route path="/favorites" element={<FavoritesPage />} />
                      <Route path="/admin" element={<AdminPage />} />
                      <Route path="/admin/customers/:uid" element={<CustomerCRMProfile />} />
                      <Route path="/payment/success" element={<PaymentSuccessPage />} />
                      <Route path="/payment/cancel" element={<PaymentCancelPage />} />
                      <Route path="/pages/:slug" element={<StaticPage />} />
                      <Route path="/verify-email" element={<VerifyEmailPage />} />
                      <Route path="/unsubscribe" element={<UnsubscribePage />} />
                      <Route path="/auth-callback" element={<AuthCallback />} />
                      <Route path="/auth/google" element={<GoogleOAuthCallback />} />
                      <Route path="/help-advice" element={<HelpAdvicePage />} />
                      <Route path="/help-advice/author/:slug" element={<ExpertAuthorPage />} />
                      <Route path="/help-advice/:slug" element={<HelpAdviceGuidePage />} />
                      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                      <Route path="/reset-password" element={<ResetPasswordPage />} />
                    </Routes>
                  </main>
                  <Footer />
                  <CookieBanner />
                  <UploadTray />
                  <Toaster position="top-right" richColors />
                </BrowserRouter>
                </UploadManagerProvider>
                </ConsentProvider>
              </FavoritesProvider>
            </CartProvider>
          </PricingProvider>
        </SettingsProvider>
      </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
